// const BASEURL = "https://accounts.keelis.in/graphql/"; // testing accounts old server
// const  BASEURL = "https://crmbk.keelis.in/graphql/";   //live
// const BASEURL = "13.234.176.236:80001/graphql/"; //AWS
// const BASEURL = "http://crmdevbk.athithishala.com/graphql/"; // Dev Server
const BASEURL = "https://egcrmbk.athithishala.com/graphql/";
 
// const BASEURL = "https://crmdemobk.keelis.in/graphql/"; //demo
// const BASEURL = "https://crmtest.keelis.in/";
// const BASEURL = "crmbk.keelis.in/graphql/"; // live server
// const BASEURL = "http://crmtestbk.athithishala.com/graphql/"; //Testing Server
// const BASEURL = "http://82.180.146.195:5002/graphql/" //Windows URL
// const BASEURL = "http://crmbackupbk.keelis.in/graphql/"; //Backup Server
// const BASEURL = "https://crmgalaxydemobk.keelis.in/graphql/"; //Galaxy Demo
// const BASEURL ="https://crmshakirdemobk.keelis.in/graphql/"; //Shakir Demo
// const BASEURL = "http://www.crmcitypestdemobk.keelis.in/graphql/" // City Types Demo
// const BASEURL = "https://egcrmbk.athithishala.com/graphql/"; //EverGuard Single Login
export default BASEURL;